export const PRICE_LEVELS = [1, 2, 3] as const;

export type PriceLevel = typeof PRICE_LEVELS[number];

export const isPriceLevel = (value: unknown): value is PriceLevel =>
  PRICE_LEVELS.includes(Number(value) as PriceLevel);

export const normalizePriceLevel = (value: unknown): PriceLevel | null => {
  const level = Number(value);
  if (!Number.isFinite(level) || level < 1) return null;
  return Math.min(Math.round(level), 3) as PriceLevel;
};
